import _ from 'lodash';
import { defaultViewPropsGetter } from 'library-@/utils/get-params';
import store from '../vuex/store';
export const pluginsMapByName = new Map();
export const comparePluginsMapByName = new Map();
export let manifests = [];
export let compareManifests = [];

export const routeAppender = {
    components: {},
    props: {},
    children: [],
};

export const compareRouteAppender = {
    components: {},
    props: {},
    children: [],
};

export const SIDES = {
    LEFT: 'left',
    RIGHT: 'right',
    SINGLE: 'single',
};
const requireAll = context => context.keys()
    .map(context);

const allManifests = [
    // eslint-disable-next-line
    ...requireAll(require.context('./', true, /manifest\.js/)),
    // CAS微前端入口
    // eslint-disable-next-line
    ...requireAll(require.context('./CAS/', true, /manifest\.js/)),
    // 支持用Alias指向第三方包的文件夹，可以是node_module
    // ...requireAll(require.context('@analytics/patentViewSubView', false, /manifest\.js/))
]
    .map(item => (_.get(item, 'default.name') ? item.default : item));

// Claim Charting V2 插件名（独立路由，不走 manifest 系统）
export const CLAIM_CHARTING_V2_PLUGIN_NAME = 'claim-charting-v2';

export const fullViewRouterNames = [
    ...allManifests
        .filter((item) => item.fullView)
        .map(item => item.name),
    CLAIM_CHARTING_V2_PLUGIN_NAME, // 手动添加 V2，触发 FullViewRoot 布局
];

export function install() {
    manifests = allManifests
        .filter(mf => mf.left || mf.right) // 没有子的
        .sort(function(a, b) {
            return (a.tabIndex - b.tabIndex);
        });

    manifests.forEach((pluginManifest) => {
        if (pluginsMapByName.has(pluginManifest.name)) {
            console.error(`Same subViewComponent name found: ${pluginManifest.name}`);
        }
        pluginsMapByName.set(pluginManifest.name, { ...pluginManifest });
        routeAppender.components[pluginManifest.name] = pluginManifest.getComponent;

        routeAppender.props[pluginManifest.name] = (route) => {
            return {
                ...defaultViewPropsGetter(route),
                pluginsMapByName,
            };
        };
    });

    return routeAppender;
}

export function installCompareViewPlugins() {
    compareManifests = allManifests
        .filter(mf => mf.compareView) // 没有子的
        .sort(function(a, b) {
            return (a.tabIndex - b.tabIndex);
        });

    compareManifests.forEach((pluginManifest) => {
        if (comparePluginsMapByName.has(pluginManifest.name)) {
            console.error(`Same subViewComponent name found: ${pluginManifest.name}`);
        }
        comparePluginsMapByName.set(pluginManifest.name, { ...pluginManifest });
        compareRouteAppender.components[pluginManifest.name] = pluginManifest.getComponent;

        compareRouteAppender.props[pluginManifest.name] = (route) => {
            return {
                ...defaultViewPropsGetter(route),
                comparePluginsMapByName,
            };
        };
    });

    return compareRouteAppender;
}

export function installTopViewPlugins() {

    const routes = [
        // {
        //     path: `/overview`,
        //     props: defaultViewPropsGetter,
        //     component: Overview,
        //     children: [
        //         {
        //             path: '/thumb',
        //             name: 'overview/thmb',
        //             component: Thumb
        //         },
        //     ]
        // }
    ];

    let topManifests = allManifests
        .filter(mf => mf.exclusiveRoutePath);

    topManifests.forEach((pluginManifest) => {
        pluginsMapByName.set(pluginManifest.name, { ...pluginManifest });

        const pluginManifestChildren = (pluginManifest.children || []);
        const routeItemTop = {
            meta: {
                pluginName: pluginManifest.name,
            },
            path: pluginManifest.exclusiveRoutePath,
            props: defaultViewPropsGetter,
            component: pluginManifest.getComponent,
        };

        if (pluginManifestChildren.length) {
            routeItemTop.children = [];
        }
        pluginManifestChildren.forEach((subviewPluginName, index) => {
            const subViewManifest = pluginsMapByName.get(subviewPluginName);
            if (!subViewManifest) {
                throw Error(`manifests of ${subviewPluginName} invalid: No children ${subviewPluginName}: ${JSON.stringify(pluginManifest.children)}`);
            }
            if (!subViewManifest.singleView) {
                console.error(`${subViewManifest.name} not allowed in singleView! (Required via ${pluginManifest.name})`);
            }
            if (index === 0) {
                routeItemTop.children.push({
                    path: '',
                    name: pluginManifest.name,
                    redirect: {
                        name: `${pluginManifest.name}/${subViewManifest.name}~exclusiveRoutePath`,
                    },
                });
            }
            routeItemTop.children.push({
                path: `${subViewManifest.name}`,
                name: `${pluginManifest.name}/${subViewManifest.name}~exclusiveRoutePath`,
                component: subViewManifest.getComponent,
                props: defaultViewPropsGetter,
            });
        });

        routes.push(routeItemTop);
    });

    // Claim Charting V2 路由配置（下拉菜单式入口）
    routes.push({
        path: '/claim-charting/v2',
        name: 'claim-charting-v2',
        component: () => import('@/components/claim-charting-v2/ClaimChartingV2Container.vue'),
        redirect: '/claim-charting/v2/extraction', // 默认重定向到第一个子路由
        meta: {
            pluginName: CLAIM_CHARTING_V2_PLUGIN_NAME, // 触发 FullViewRoot 布局
        },
        children: [
            {
                path: 'extraction',
                name: 'claim-charting-v2-extraction',
                component: () => import('@/components/claim-charting-v2/pages/FeatureExtraction.vue'),
                meta: {
                    pluginName: CLAIM_CHARTING_V2_PLUGIN_NAME,
                },
            },
            {
                path: 'cc',
                name: 'claim-charting-v2-cc',
                component: () => import('@/components/claim-charting-v2/pages/FeatureCompareV2.vue'),
                redirect: { name: 'claim-charting-v2-cc-step1' }, // 访问 /cc 时重定向到 step1
                meta: {
                    pluginName: CLAIM_CHARTING_V2_PLUGIN_NAME,
                },
                children: [
                    {
                        path: 'step1',
                        name: 'claim-charting-v2-cc-step1',
                        component: () => import('@/components/claim-charting-v2/pages/CompareSetupStep1.vue'),
                        meta: {
                            pluginName: CLAIM_CHARTING_V2_PLUGIN_NAME,
                        },
                    },
                    {
                        path: 'step2',
                        name: 'claim-charting-v2-cc-step2',
                        component: () => import('@/components/claim-charting-v2/pages/CompareSetupStep2.vue'),
                        meta: {
                            pluginName: CLAIM_CHARTING_V2_PLUGIN_NAME,
                        },
                    },
                    {
                        path: 'result',
                        name: 'claim-charting-v2-cc-result',
                        component: () => import('@/components/claim-charting-v2/pages/CompareResultPage.vue'),
                        meta: {
                            pluginName: CLAIM_CHARTING_V2_PLUGIN_NAME,
                        },
                    },
                ],
            },
            {
                path: 'eou',
                name: 'claim-charting-v2-eou',
                component: () => import('@/components/claim-charting-v2/pages/EouAnalysis.vue'),
                meta: {
                    pluginName: CLAIM_CHARTING_V2_PLUGIN_NAME,
                },
            },
        ],
    });

    return routes;
}

export function getFilteredManifestList(side, $store = store) {
    let ret = _.filter(manifests, { [side]: true });
    ret = ret.filter(function(manifest) {
        if (!manifest.aclReadPath) {
            return true;
        }
        if (!$store.state) {
            console.error('getFilteredManifestList need vuex $store as 2nd param!');
        }
        return _.get($store.state, manifest.aclReadPath.replace('/', '.'));
    });
    return ret;
}

export function getFilteredCompareManifestList(side, $store = store) {
    let ret = [...compareManifests];
    ret = ret.filter(function(manifest) {
        if (!manifest.aclReadPath) {
            return true;
        }
        if (!$store.state) {
            console.error('getFilteredManifestList need vuex $store as 2nd param!');
        }
        return _.get($store.state, manifest.aclReadPath.replace('/', '.'));
    });
    return ret;
}
